import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectIsEmbeddedMessagingCoreFeatureFlagOn } from 'core/userContext';
import { SideNav } from 'ui/sideNav';
import { useWhatsAppMessageChannelFeature } from 'utils/hooks/featureFlags';
import { NAV_LINKS } from '../constants';
import { usePagination } from '../hooks';

const getEffectiveLinks = (
  isEmbeddedOn: boolean,
  isWhatsAppOn: boolean,
  links: {
    name: string;
    pathname: string;
  }[],
) => {
  const baseLinks = [...links];
  if (isEmbeddedOn) {
    baseLinks.push({
      name: 'Embedded',
      pathname: '/settings/channels/embedded',
    });
  }
  if (isWhatsAppOn) {
    baseLinks.push({
      name: 'WhatsApp',
      pathname: '/settings/channels/whatsApp',
    });
  }
  return baseLinks;
};

export const ChannelsSideNav = () => {
  const isEmbeddedOn = useSelector(selectIsEmbeddedMessagingCoreFeatureFlagOn);
  const { isWhatsAppEnabled: isWhatsAppFFOn } = useWhatsAppMessageChannelFeature();

  const { itemsPerPage } = usePagination();
  const { header, links } = NAV_LINKS[0];
  const effectiveLinks = getEffectiveLinks(isEmbeddedOn, isWhatsAppFFOn, links);

  const navLinks = useMemo(
    () => effectiveLinks.map((link) => ({ ...link, search: `?pageSize=${itemsPerPage}` })),
    [itemsPerPage],
  );

  return <SideNav linksAndSections={[{ header, links: navLinks }]} />;
};
